import React, { useEffect, useState, useMemo } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import TableContainerV1 from "components/Common/TableContainerV1";

import { getproductReport } from "../../../helpers/UAM/report.helper"

import * as XLSX from 'xlsx';

const ProductReportSu = props => {

  //meta title
  document.title = "Product Reports | DMS";

  const [productReportData, setProductReportData] = useState([]);

  const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0, })
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("UPC");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [sortingOptions, setSortingOptions] = useState({ column: "", isAsc: false, optionalColumn: [], });


  // Customber Column
  const columns = useMemo(
    () => [

      {
        Header: 'Product Name',
        accessor: 'productName',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Product Code',
        accessor: 'productCode',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
          ;
        }
      },
      {
        Header: 'Category',
        accessor: 'categoryName',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Sub Category',
        accessor: 'subCategoryName',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Model Name',
        accessor: 'modelName',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Total Units Sold',
        accessor: 'totalUnitsSold',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },

    ],
  );

  useEffect(() => {
    fetchProductReport({})
  }, [])

  const fetchProductReport = (data) => {
    getproductReport(data)
      .then((response) => {
        if (response.status && response.code == 200) {
          setProductReportData(response.data.data);
          const { totalItems, totalPages, currentPage } = response.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        } else {
          setPagination({ totalRecords: 0 })
          setProductReportData([])
        }

      })
      .catch((err) => { console.log(err) })
  }

  const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus) => {
    setPageSize(pageSize);
    setCurrentPage(page)
    fetchProductReport({ page, limit: pageSize, searchKey, columnName, sortingOrder })
  };

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(currentPage, pageSize, searchValue, columnName, sortingOrder);
  };

  const handleSearchFilter = (value, pageSize) => {
    const newValue = value !== undefined ? value : "";
    setSearchValue(newValue);
    handlePageChange(1, pageSize, newValue);

  };
  const handleClearSearch = () => {
    setSearchValue("");
    handlePageChange(1, pageSize, "");

  };
  const downloadExcel = () => {
    let dataWithModifiedCol = productReportData.map(report => {
      let newReport = {
        "Product Name": report.productName,
        "Product Code": report.productCode,
        "Category": report.categoryName,
        "Sub Category": report.subCategoryName,
        "Model Name": report.modelName,
        "Total Units Sold": report.totalUnitsSold,
      }
      return newReport
    })
    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    const sheetData = XLSX.utils.json_to_sheet(dataWithModifiedCol);
    // Add the sheet to the workbook
    XLSX.utils.book_append_sheet(workbook, sheetData, 'ProductReport');
    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, 'Product_Report.xlsx');
  };

  const buttonSection = (
    <div className="text-sm-end">

      <Button
        type="button"
        color="success"
        className="btn-rounded mb-2 me-2"
        onClick={downloadExcel}
      >
        <i className="bx bx-archive-in me-1" />
        {'Download'}
      </Button>

    </div>);
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Reports" breadcrumbItem="Product Report" />
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <TableContainerV1
                  columns={columns}
                  data={productReportData}
                  pagination={pagination}
                  handlePageChange={handlePageChange}
                  searchHelperText="Search by Product Name, Product Code, Category, Sub Category"
                  handleSearchFilter={handleSearchFilter}
                  customSection={buttonSection}
                  sortOptions={sortingOptions}
                  handleSortColumn={handleSortColumn}
                  handleClearSearch={handleClearSearch}
                  className="custom-header-css"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProductReportSu;
